// @ts-nocheck
import { Key, useEffect, useState, useRef } from "react";
import { useParams } from "react-router-dom";

import { Button, Card, Col, Container, Row, Form } from "react-bootstrap";
import { getGearFromOrder, getOrderDetails, getMonteringsInfo} from "../components/Backend.tsx";
import Faktura from "../components/Faktura.tsx";
import OrderList from "../components/OrderList.tsx";
import StripePayment from "../components/StripePayment.tsx";
import Vipps from "../components/Vipps.tsx";
import ModalComp from "../components/ModalComp.tsx";
import AddOnsForPackage from "../components/AddOnsForPackage.tsx";

import { getFunctions, httpsCallable } from "firebase/functions";
import Loading from "../components/Loading.tsx";
import { app } from "../firebase1.ts";
import { useNavigate } from "react-router-dom";
import { addDoc, collection, doc, getDoc } from "firebase/firestore";
import { db } from "../firebase1.ts";
import { BsMusicNote } from "react-icons/bs";
import { GoPlus } from "react-icons/go";
import { FiDownload } from "react-icons/fi";
import { getExtras, checkAvailability } from "../components/Backend.tsx";
import AddExtraEquiptmentCard from "../components/AddExtraEquiptmentCard.tsx";
import img from "../img/pay_with_vipps.png";
import { posix } from "path";

import Cookies from "universal-cookie";

const OrderDetail = () => {
  let orderId = useParams();
  const [order, setOrder] = useState(null);
  const [equipment, setEquipment] = useState([]);


  const functions = getFunctions(app, 'europe-west1');

  const cookies = new Cookies()

  const unlockDoorButton = httpsCallable(functions, "unlockScript");
  const createStripeCheckout = httpsCallable(functions, "createStripeCheckout");
  const createVippsCheckout = httpsCallable(functions, "createVippsCheckout");
  const createVippsLogin = httpsCallable(functions, "createVippsLogin")
  const createVippsAddonsCheckout = httpsCallable(
    functions,
    "createVippsAddonsCheckout"
  );
  const createInvoiceURL = httpsCallable(functions, "createInvoiceURL");

  //KOBLE PÅ "FUNGERTE DET IKKE Å ÅPNE DØRA"-KNAPP
  const unlockDoorSendSMSButton = httpsCallable(functions, "unlockSMS");

  useEffect(() => {
    const checkAndFixNaNValues = async () => {
      try {
        const orderDetails = await getOrderDetails(orderId.orderId);
        const utstyr = orderDetails?.utstyr || {};

        let updateRequired = false;

        for (const [key, value] of Object.entries(utstyr)) {
          if (isNaN(value)) {
            utstyr[key] = 0; // Sett NaN til 0
            updateRequired = true;
          }
        }

        if (updateRequired) {
          const docRef = doc(db, "sales", orderId.orderId);
          await updateDoc(docRef, { utstyr });
          console.log("Oppdatert utstyr med NaN-verdier til 0.");
        }

        setOrder(orderDetails); // Setter order etter oppdatering, hvis nødvendig
      } catch (error) {
        console.error("Feil ved sjekk og oppdatering av NaN-verdier:", error);
      }
    };

    checkAndFixNaNValues();
  }, [orderId.orderId]);

  const fetchData = async (chosenGears: Array) => {
    const equipmentInOrder = await getGearFromOrder(chosenGears);
    setEquipment(equipmentInOrder);
  };
  const fetchMonteringsinfo = async () => {
    if(order !== null){
      const docRef = doc(db, "packages", order.pakkeType);
      const monteringsInfo = await getMonteringsInfo(order.pakkeType);
      try {
        const doc = await getDoc(docRef);
        setMonteringsInfo(monteringsInfo);
      } catch (e) {
        console.log(e);
      }   
    } else {
      console.error("Order finnes ikke!")
      console.log(order)
    }
  };

  const fetchPossibleEquipmentOnPackage = async () => {
    let docRef = doc(db, "packages", order.pakkeType);
    let extras = await getExtras(order.pakkeType);
    try {
      const doc = await getDoc(docRef);
      setPossibleEquipment(extras);
      setLoadingExtraEquiptment(false);
    } catch (e) {
      console.log(e);
    }
  };

  const [paymentType, setPaymentType] = useState("");

  const [showVipps, setShowVipps] = useState(false);
  const [showCardPayment, setShowCardPayment] = useState(false);
  const [showFaktura, setShowFaktura] = useState(false);

  const [newEquipment, setNewEquipment] = useState([]);

  const [isShownVipps, setIsShownVipps] = useState(false);

  const [isShownStripe, setIsShownStripe] = useState(false);

  const [chosenGear, setChosenGear] = useState({});

  const [showModal, setShowModal] = useState(false);
  const handleClose = () => (setShowModal(false), setCounter(5));
  const [sentSMSCode, setSentSMSCode] = useState(0);

  const [usInfo, setUserInfo] = useState(); 
  const [doneVippsLogin, setDoneVippsLogin] = useState(false);

  //Monteringsinfo 
  const [monteringsInfo, setMonteringsInfo] = useState([]);
  const [pakketype, setPackage] = useState("");

  //Add extra equipment
  const [showExtraEquipmentModal, setShowExtraEquipmentModal] = useState(false);
  const [possibleEquipment, setPossibleEquipment] = useState([]);
  const [loadingExtraEquiptment, setLoadingExtraEquiptment] = useState(true);
  const [addOnPrice, setAddOnPrice] = useState(0);
  const [extraEquiptmentPurchasedPrice, setExtraEquiptmentPurchasedPrice] =
    useState(0);
  const [setNumberOfExtraOrders, setSetNumberOfExtraOrders] = useState(0);

  const [loading, setLoading] = useState(false);
  const buttonStyles = loading
    ? "text-white !bg-[#e57e22] !border-none !hover:bg-[#e57e22] !opacity-100 hover:border-none text-center ml-16 mt-3 py-2.5 px-4 cursor-not-allowed"
    : "text-white !border-none !bg-none hover:bg-white";

  const [extrasStatus, setExtrasStatus] = useState([]);
  const [
    showExtraEquipmentUnavailableModal,
    setShowExtraEquipmentUnavailableModal,
  ] = useState(false);

  const [showConfirmExtraEquipmentModal, setShowConfirmExtraEquipmentModal] =
    useState(false);

  useEffect(() => {
    if (showConfirmExtraEquipmentModal === false) {
      setAddOnPrice(0);

      for (let i = 0; i < possibleEquipment.length; i++) {
        possibleEquipment[i].count = 0;
      }
    }
  }, [showConfirmExtraEquipmentModal]);

  function addExtraEquiptmentPrice() {
    let addOnPrice: number = 0;

    if (order.tid.totalDays === 0) { // (products.startPris*products.count) + (products.dagsPris * daysBetween * products.count)
      Object.keys(possibleEquipment).forEach(function (key) {
        addOnPrice +=
          (possibleEquipment[key].startPris * possibleEquipment[key].count) 
          + 
          (possibleEquipment[key].dagsPris * possibleEquipment[key].count);
      });
    } else {
      Object.keys(possibleEquipment).forEach(function (key) { // (products.startPris*products.count) + (products.dagsPris * daysBetween * products.count)
        addOnPrice +=
          (possibleEquipment[key].startPris * possibleEquipment[key].count)
          + 
          (possibleEquipment[key].dagsPris * order.tid.totalDays * possibleEquipment[key].count)

      });
    }

    setAddOnPrice(addOnPrice);
    return addOnPrice;
  }

  async function checkAvaliabilityOfPackage() {
    let extras = {};
    possibleEquipment.forEach((a) => (extras[a.id] = parseInt(a.count)));

    let lager = order.lager;
    let startDate = new Date(order.startDate * 1000);
    let endDate = new Date(order.endDate * 1000);

    let ca = await checkAvailability(extras, lager, startDate, endDate);
    setExtrasStatus(ca);

    if (ca.available === false) {
      setShowExtraEquipmentModal(false);
      setShowExtraEquipmentUnavailableModal(true);
    }

    if (ca.available === true) {
      setShowExtraEquipmentModal(false);
      setShowConfirmExtraEquipmentModal(true);
    }
  }

  useEffect(() => {
    if (showExtraEquipmentModal === true) {
      fetchPossibleEquipmentOnPackage();
    }
  }, [showExtraEquipmentModal]);

  function handleNewOrder() {
    setLoading(true);
    let gear = {};
    possibleEquipment.map((item) => {
      if (item.count !== 0) {
        gear[item.id] = item.count;
      }
    });

    let data = {
      client_reference_id: orderId.orderId,
      addonOrder: {
        price: addOnPrice,
        gear: gear,
      },
    };

    vippsAddonThing(data);
  }

  //Damage report
  const [showDamageModal, setShowDamageModal] = useState(false);
  const [damageReportText, setDamageReportText] = useState("");
  const [damageReportEquiptment, setDamageReportEquiptment] = useState("");
  const [damageReportCheckbox, setDamageReportCheckbox] = useState(false);
  const [showDamageReportSentModal, setShowDamageReportSentModal] =
    useState(false);

  const [counter, setCounter] = useState(39);
  let interval = useRef();

  function timer() {
    interval.current = setInterval(() => {
      setCounter((counter) => counter - 1);
    }, 1000);

    if (counter === 0) {
      clearTimeout(interval);
    }

    return () => clearInterval(interval);
  }

  useEffect(() => {
    if (counter === 0) {
      clearInterval(interval.current);
    }
  }, [counter]);

  useEffect(() => {

    const fetchOrderDetails = async () => {
      console.log("Denne kjører");
      console.log(orderId)
      console.log(orderId.orderId)
      try {
        const details = await getOrderDetails(orderId.orderId);
        setOrder(details);
        localStorage.setItem("orderId", orderId.orderId);
        localStorage.setItem(orderId.orderId, details);
      } catch (error) {
        console.error("Feil ved henting av orderdetaljer:", error);
      }
    };
  
    fetchOrderDetails();
  }, [orderId.orderId]);

  useEffect(() => {
    let gearChosen = {};
    let totalAddOnPrice = 0;
    let numberOfExtraOrders = 0;

    if (order !== null) {
      let utstyr = order.utstyr;
      let addOnOrders = order.addonOrders;

      // Process original order items
      for (const i in utstyr) {
        if (utstyr[i] > 0) {
          gearChosen[i] = utstyr[i];
        }
      }

      // Check if addOnOrders exists and is an array
      if (addOnOrders && Array.isArray(addOnOrders)) {
        // Process add-on orders
        addOnOrders.forEach((addOnOrder) => {
          if (addOnOrder.paid === true) {
            for (const i in addOnOrder.gear) {
              if (addOnOrder.gear[i] > 0) {
                gearChosen[i] = (gearChosen[i] || 0) + addOnOrder.gear[i];
              }
            }
            numberOfExtraOrders++;
            totalAddOnPrice += addOnOrder.price;
          }
        });
      }
    }
    setSetNumberOfExtraOrders(numberOfExtraOrders);
    setExtraEquiptmentPurchasedPrice(totalAddOnPrice);
    setChosenGear(gearChosen);
    fetchMonteringsinfo();
  }, [order]);

  const navigate = useNavigate();

  const routeChange = () => {
    let path = `/kontakt`;
    navigate(path);
  };

  useEffect(() => {
    if (chosenGear !== null) {
      fetchData(chosenGear);
    }
  }, [chosenGear]);


  const stripe = Stripe("pk_live_8l3d9BrD9cvBP2UHwTyEhstm00uInl61cR");

  let data = {
    client_reference_id: orderId.orderId,
  };

  async function sendDamageReport(equiptment, text, checkbox) {
    let today = new Date();
    let lager = order.lager;
    let tlf = order.tlf;
    let orderID = orderId.orderId;
    await addDoc(collection(db, "damage"), {
      tid: today,
      lager: lager,
      tlf: tlf,
      orderId: orderID,
      utstyr: equiptment,
      beskrivelse: text,
      brukbartUtstyr: checkbox,
    })
      .then(() => {
        console.log("Damage report sent");
        setShowDamageModal(false);
        setDamageReportCheckbox(false);
        setDamageReportEquiptment("");
        setDamageReportText("");
        setShowDamageReportSentModal(true);
      })
      .catch(function (error) {
        console.error("Error adding document: ", error);
      });
  }

  function stripeThing(data: any) {
    console.log(data);
    createStripeCheckout(data).then((response) => {
      const sessionId = response.data.id;
      const client_reference_id = response.data.client_reference_id;
      stripe.redirectToCheckout({
        sessionId: sessionId,
        clientReferenceId: client_reference_id,
      });
    });
  }

  function vippsThing(data: any) {

    createVippsCheckout(data).then((response) => {
      const clientUrl = response.data.url;
      //Send bruker til clientUrl
      window.location.href = clientUrl;
    });
  }

 

   function vippsLoginFunction(data: any) {
    localStorage.setItem(orderId, order)
    // DENNE ER GOOD
      createVippsLogin(data).then((response) => {
      const clientUrl = response.data.loginUrl
      

    console.log(response.data.loginUrl)
    console.log({reference_id: data.client_reference_id})
      window.location.href = clientUrl;
    });
  }

  const handleRedirect = async () => {
    console.log("OrderId: ", orderId);
    console.log("ORDER INFO: ", order);

    // Lagrer order-info i localStorage
    localStorage.setItem(orderId, JSON.stringify(order));

    // Sjekker om order-info er lagret i localStorage
    console.log("GETTING ORDER AFTER SET: ", JSON.parse(localStorage.getItem(orderId)));
}

useEffect(() => {
    handleRedirect();
}, [order]);

  useEffect( () => {
    handleRedirect()
    console.log(orderId)
    console.log(cookies.get({orderId: "aQelq7JSxarkN0xAIVSI"}))
  }, [order]) 

  function vippsAddonThing(data: any) {
    createVippsAddonsCheckout(data).then((response) => {
      const clientUrl = response.data.url;
      //Send bruker til clientUrl
      window.location.href = clientUrl;
    });
  }
  function unlockDoor(data: any) {
    unlockDoorButton(data).then((response) => {
      const clientUrl = response.data.url;
      //Send bruker til clientUrl
      window.location.href = clientUrl;
    });
  }

  function unlockDoorWithSMS(data: any) {
    unlockDoorSendSMSButton(data).then((response) => {
      const clientUrl = response.data.url;
      //Send bruker til clientUrl
      window.location.href = clientUrl;
    });
  }

  function handleDamageReport() {
    setShowDamageModal(true);
  }

  function handleDoorOpening() {
    unlockDoor(data);
    setShowModal(true);
    timer();
  }

  function handleSMSCode() {
    unlockDoorWithSMS(data);
    setSentSMSCode(1);
  }

  function capitalize(s: string) {
    return s.substring(0, 1).toUpperCase() + s.substring(1).toLowerCase();
  }

  let options = {
    weekday: "long",
    year: "numeric",
    month: "long",
    day: "numeric",
  };

  function setDetailsForFaktura(
    formNavnMottaker: any,
    formOrgNummer: any,
    formAdresse: any,
    formPostNummer: any,
    formEmail: any,
    formMobil: any
  ) {
    let fakturaDetails = {
      navnMottaker: formNavnMottaker,
      orgNummer: formOrgNummer,
      adresse: formAdresse,
      postNummer: formPostNummer,
      email: formEmail,
      mobil: formMobil,
    };
  }

  let today = new Date().setHours(0, 0, 0, 0) / 1000;

  return (
    <div>
      {order === null ? (
        <Col
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            textAlign: "center",
            minHeight: "100vh",
          }}
        >
          <Loading color={"#e57e22"} />
        </Col>
      ) : (
        <>
          <ModalComp
            show={showDamageReportSentModal}
            closeModal={() => setShowDamageReportSentModal(false)}
            hide={() => setShowDamageReportSentModal(false)}
            title="Takk"
            footer={
              <Button
                variant="secondary"
                className="text-white bg-[#24292e] text-left ml-16 mt-3"
                onClick={() => setShowDamageReportSentModal(false)}
              >
                Ok!
              </Button>
            }
            body={
              <>
                <div className="text-xl mt-2">Takk for din rapportering!</div>
                <br />
                Husk å sette defekt utstyr til side og merk med rød teip, om
                mulig. Ødelagte kabler kastes.
              </>
            }
          />

          <ModalComp
            show={showModal}
            closeModal={() => setShowModal(false)}
            hide={handleClose}
            title="Åpne dør til lager"
            footer={
              <Button
                variant="secondary"
                className="text-white bg-[#24292e] text-left ml-16 mt-3"
                onClick={handleClose}
              >
                Lukk
              </Button>
            }
            body={
              <>
                {counter !== 0 ? (
                  <div className="pl-8 pr-6 pt-6 mb-2 text-sm">
                    Døren vil nå bli åpnet for deg, vennligst vent:{" "}
                    <div className="text-2xl font-bold text-center my-6">
                      {counter}
                    </div>
                  </div>
                ) : (
                  <div className="pl-8 pr-6 pt-6 mb-2 text-sm">
                    Funket det ikke? Trykk på knappen under for å få tilsendt en
                    kode på SMS for å åpne døren{" "}
                    <div>
                      {sentSMSCode === 0 ? (
                        <Button
                          className="lg:mt-0 mt-3 tracking-wide h-12 w-100"
                          onClick={() => handleSMSCode()}
                          style={{
                            backgroundColor: "#e57e22",
                            border: "none",
                            fontWeight: 400,
                          }}
                        >
                          Få tilsendt kode på SMS
                        </Button>
                      ) : (
                        <div className="text-xl font-bold text-center my-8">
                          Kode er sendt
                        </div>
                      )}
                    </div>
                  </div>
                )}
              </>
            }
          />

          <ModalComp
            show={showDamageModal}
            closeModal={() => setShowDamageModal(false)}
            hide={() => setShowDamageModal(false)}
            title="Rapporter skade"
            body={
              <>
                <Form.Control
                  as="select"
                  aria-label="Legg til"
                  onChange={(e) => setDamageReportEquiptment(e.target.value)}
                  className="mt-2"
                >
                  <option style={{ fontStyle: "bold" }}>
                    Velg utstyr - én skade per melding
                  </option>
                  {equipment.map(
                    (products: {
                      id: Key | null | undefined;
                      bilde: string | undefined;
                      beskrivelse: string | undefined;
                      navn: string | undefined;
                      count: number | undefined;
                    }) => (
                      <option value={products.navn}>{products.navn}</option>
                    )
                  )}
                </Form.Control>

                <Form className="mt-2">
                  <Form.Group
                    className="mt-1 mb-1"
                    controlId="form.Comment"
                    onChange={(e) => setDamageReportText(e.target.value)}
                  >
                    <Form.Control
                      className="font-medium tracking-widers text-black"
                      value={`${damageReportText}`}
                      as="textarea"
                      placeholder="Beskrivelse av skade"
                      rows={3}
                    />
                  </Form.Group>
                </Form>

                <Row className="mb-2">
                  <Col sm={12} lg={6}>
                    <div className="float-left">
                      <Form.Check
                        className="mt-2 float-right"
                        onChange={(e) =>
                          setDamageReportCheckbox(e.target.checked)
                        }
                        type="switch"
                        id="switch-damage-report"
                        label="Utstyr kan ikke brukes"
                      ></Form.Check>
                    </div>
                  </Col>
                  <Col sm={12} lg={6}>
                    <div className="float-right mt-2 ">
                      <Button
                        variant="secondary"
                        className="text-white bg-[#24292e]"
                        onClick={() => {
                          sendDamageReport(
                            damageReportEquiptment,
                            damageReportText,
                            damageReportCheckbox
                          );
                        }}
                      >
                        Send
                      </Button>
                      <Button
                        variant="secondary"
                        className="text-[#24292e] border-[#24292e] text-left ml-2"
                        onClick={() => setShowDamageModal(false)}
                      >
                        Avbryt
                      </Button>
                    </div>
                  </Col>
                </Row>
              </>
            }
          />

          <ModalComp
            show={showDamageReportSentModal}
            closeModal={() => setShowDamageReportSentModal(false)}
            hide={() => setShowDamageReportSentModal(false)}
            title="Takk"
            footer={
              <Button
                variant="secondary"
                className="text-white bg-[#24292e] text-left ml-16 mt-3"
                onClick={() => setShowDamageReportSentModal(false)}
              >
                Ok!
              </Button>
            }
            body={
              <>
                <div className="text-xl mt-2">Takk for din rapportering!</div>
                <br />
                Husk å sette defekt utstyr til side og merk med rød teip, om
                mulig. Ødelagte kabler kastes.
              </>
            }
          />

          <ModalComp
            show={showModal}
            closeModal={() => setShowModal(false)}
            hide={handleClose}
            title="Åpne dør til lager"
            footer={
              <Button
                variant="secondary"
                className="text-white bg-[#24292e] text-left ml-16 mt-3"
                onClick={handleClose}
              >
                Lukk
              </Button>
            }
            body={
              <>
                {counter !== 0 ? (
                  <div className="pl-8 pr-6 pt-6 mb-2 text-sm">
                    Døren vil nå bli åpnet for deg, vennligst vent:{" "}
                    <div className="text-2xl font-bold text-center my-6">
                      {counter}
                    </div>
                  </div>
                ) : (
                  <div className="pl-8 pr-6 pt-6 mb-2 text-sm">
                    Funket det ikke? Trykk på knappen under for å få tilsendt en
                    kode på SMS for å åpne døren{" "}
                    <div>
                      {sentSMSCode === 0 ? (
                        <Button
                          className="lg:mt-0 mt-3 tracking-wide h-12 w-100"
                          onClick={() => handleSMSCode()}
                          style={{
                            backgroundColor: "#e57e22",
                            border: "none",
                            fontWeight: 400,
                          }}
                        >
                          Få tilsendt kode på SMS
                        </Button>
                      ) : (
                        <div className="text-xl font-bold text-center my-8">
                          Kode er sendt
                        </div>
                      )}
                    </div>
                  </div>
                )}
              </>
            }
          />

          {/* Add extra equiptment modal */}
          <ModalComp
            show={showExtraEquipmentModal}
            closeModal={() => setShowExtraEquipmentModal(false)}
            hide={() => setShowExtraEquipmentModal(false)}
            title="Velg ekstrautstyr"
            size="lg"
            body={
              <>
                <Container className="mb-10">
                  <Row>
                    {loadingExtraEquiptment === false ? (
                      <>
                        {possibleEquipment.map((products, index) => {
                          return (
                            <Col lg={{ span: 12 }} className="">
                              <AddExtraEquiptmentCard
                                image={products.bilde}
                                name={products.navn}
                                desc={products.beskrivelse}
                                count={products.count}
                                priceFrom={
                                  order.tid.totalDays === 0
                                    ? products.count === 0
                                      ? products.startPris + (products.dagsPris*order.tid.totalDays) //products.startPris + (products.dagsPris * daysBetween)
                                      : (products.startPris * products.count) + (products.dagsPris * order.tid.totalDays * products.count) // (products.startPris*products.count) + (products.dagsPris * daysBetween * products.count)
                                    : products.count === 0
                                    ? products.startPris + (products.dagsPris * order.tid.totalDays)
                                    : (products.startPris * products.count) +
                                      (order.tid.totalDays * products.dagsPris*products.count)
                                }
                                max={products.maks}
                                onChange={(e: any) => {
                                  let value = parseInt(e.target.value);
                                  //@ts-ignore
                                  products.count = value;

                                  if (e.target.value === "+ Velg") {
                                    //@ts-ignore
                                    products.count = 0;
                                  }
                                  addExtraEquiptmentPrice();
                                }}
                              />{" "}
                            </Col>
                          );
                        })}{" "}
                      </>
                    ) : (
                      <div className="flex justify-center items-center ml-9 mt-20 text-[#e57e22]">
                        <svg
                          className="w-36 h-236 animate-bounce"
                          fill="none"
                          viewBox="0 0 24 24"
                        >
                          <BsMusicNote />
                        </svg>
                      </div>
                    )}
                  </Row>
                </Container>
                <div className="float-right mb-2 -mt-2">
                  <Button
                    variant="link"
                    className="text-gray-500 "
                    onClick={() => setShowExtraEquipmentModal(false)}
                  >
                    Avbryt
                  </Button>
                  <Button
                    disabled={addOnPrice === 0 ? true : false}
                    variant="primary"
                    className="text-white bg-[#e57e22] border-none hover:bg-[#e57e22] hover:border-none px-4 py-2.5 font-bold ml-4"
                    onClick={() => {
                      checkAvaliabilityOfPackage();
                    }}
                  >
                    Neste
                  </Button>
                </div>
              </>
            }
          />

          {/* Confirm equiptment to add, and proceed to payment */}
          <ModalComp
            show={showConfirmExtraEquipmentModal}
            closeModal={() => setShowConfirmExtraEquipmentModal(false)}
            hide={() => setShowConfirmExtraEquipmentModal(false)}
            title="Fullfør bestilling av ekstrautstyr"
            size="lg"
            footer={
              <Button
                disabled={loading}
                variant="secondary"
                className={buttonStyles}
                //className="text-white bg-[#e57e22] border-none hover:bg-[#e57e22] hover:border-none text-center ml-16 mt-3 py-2.5 px-4"
                onClick={() => handleNewOrder()}
              >
                {loading ? (
                  <svg
                    className="animate-spin h-5 w-5 text-white mx-auto"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                  >
                    <circle
                      className="opacity-25"
                      cx="12"
                      cy="12"
                      r="10"
                      stroke="currentColor"
                      strokeWidth="4"
                    ></circle>
                    <path
                      className="opacity-75"
                      fill="currentColor"
                      d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                    ></path>
                  </svg>
                ) : (
                  <img src={img} />
                )}
              </Button>
            }
            body={
              <>
                <div>
                  <Card className="text-black bg-white text-left w-12/12 !border-t-1 !border-r-1 !border-b-0 !border-l-1 !rounded-none">
                    <Card.Body className="pt-2 pr-1 pl-1 pb-2">
                      <Row className="mr-4 ml-2">
                        <Col sm={9} xs={8}>
                          <div className="text-sm tracking-wider pb-2 pt-2 pl-2 text-black">
                            Ekstra utstyr
                            {possibleEquipment.map((products) => {
                              return (
                                <>
                                  {products.count !== 0 ? (
                                    <div className="pt-2 pl-4 italic font-bold">
                                      {products.navn} x {products.count}
                                    </div>
                                  ) : null}
                                </>
                              );
                            })}
                          </div>
                        </Col>
                        <Col sm={3} xs={4}>
                          <div className="text-sm tracking-wider pb-2 pt-2 pl-2 float-right text-black">
                            {addOnPrice} ,-
                            {possibleEquipment.map((products) => {
                              return (
                                <>
                                  {products.count !== 0 ? (
                                    <div className="pt-2 italic text-sm font-bold">
                                      {order.tid.totalDays === 0 ? (
                                        <>
                                          {" "}
                                          {(products.startPris *
                                            products.count) + (products.dagsPris*products.count)}{" "}
                                          ,-{" "}
                                        </>
                                      ) : (
                                        <>
                                          {(products.startPris *
                                            order.tid.totalDays * 
                                            products.count)
                                            + (products.dagsPris*products.count*order.tid.totalDays)}{" "}
                                          ,-
                                        </>
                                      )}
                                    </div>
                                  ) : null}
                                </>
                              );
                            })}
                          </div>
                        </Col>
                      </Row>
                    </Card.Body>
                  </Card>
                </div>
                <Card className="text-black bg-white text-left w-12/12 border-t-4 border-[#24292e] rounded-none">
                  <Card.Body className="pt-2 pr-1 pl-1 pb-2">
                    <Row className="mr-4 ml-2">
                      <Col sm={10}>
                        <div className="text-md tracking-wider pb-2 pt-2 pl-2 text-black">
                          <div className=" font-bold pb-1 ">
                            Totalt å betale
                          </div>
                          <div className="text-xs">
                            (Totalsum inkludert mva)
                          </div>
                        </div>
                      </Col>
                      <Col sm={2}>
                        <div className="text-md tracking-wider pb-2 pt-3 pl-2 text-black font-bold">
                          {addOnPrice},-
                        </div>
                      </Col>
                    </Row>
                  </Card.Body>
                </Card>
              </>
            }
          />

          {/** Modal for å vise utilgjengelig utstyr*/}
          <ModalComp
            show={showExtraEquipmentUnavailableModal}
            closeModal={() => setShowExtraEquipmentUnavailableModal(false)}
            hide={() => setShowExtraEquipmentUnavailableModal(false)}
            title="Utstyr ikke tilgjengelig"
            footer={
              <Button
                variant="secondary"
                className="text-white bg-[#24292e] text-left ml-16 mt-3"
                onClick={() => setShowExtraEquipmentUnavailableModal(false)}
              >
                Lukk
              </Button>
            }
            body={
              <div>
                <div className="text-sm text-light font-bold pb-2 text-black tracking-wider">
                  Følgende utstyr er dessverre ikke tilgjengelig i oppgitt
                  tidsrom:
                </div>
                {extrasStatus && extrasStatus.gearUnavailable ? (
                  extrasStatus.gearUnavailable.map((gear) => {
                    console.log(gear);
                    return (
                      <div className="tracking-wider pb-2">
                        {gear.dateUnavailable} {gear.gearName}
                      </div>
                    );
                  })
                ) : (
                  <div></div>
                )}
              </div>
            }
          />

          <Container>
            <div className="font-josefin">
              {window.innerWidth < 960 ? (
                <div className="fixed bottom-24 right-3 mx-3 z-50">
                  <Button
                    variant="secondary"
                    className="focus:ring-4 font-josefin shadow-sm transform active:scale-y-75 transition-transform rounded-full"
                    onClick={() => setShowExtraEquipmentModal(true)}
                    style={{
                      fontWeight: 1000,
                      backgroundColor: "#2289e5",
                      borderColor: "#2289e5",
                      paddingLeft: "1rem",
                      paddingRight: "1rem",
                      paddingTop: "1.0rem",
                      paddingBottom: "1.0rem",
                    }}
                  >
                    <GoPlus size={24} />
                  </Button>
                </div>
              ) : null}
              {order.paymentStatus === "cancelled" ? (
                <div className="pt-10 font-normal text-3xl tracking-wider whitespace-pre text-center">
                  Din ordre er kansellert
                </div>
              ) : null}
              {order.paymentStatus === "paid" ? (
                <>
                  <Row md={2}>
                    <Col className=" pt-10 pb-10 ">
                      <div className="pb-2 font-normal text-3xl tracking-wider whitespace-pre">
                        {order.deliveryService[0].order === true ? (
                          <div>Levering av utstyr</div>
                        ) : (
                          <div>Hent din bestilling</div>
                        )}
                      </div>
                      {today >= order.tid.startDate.seconds &&
                      today <= order.tid.endDate.seconds ? (
                        <>
                          <Button
                            variant="secondary"
                            className="bg-[#24292e] text-white tracking-wider w-100 mt-8 rounded-md pt-3 pb-3"
                            onClick={() => handleDoorOpening()}
                          >
                            Åpne dør til lager
                          </Button>
                          <Button
                            variant="secondary"
                            className=" text-black tracking-wider w-100 mt-2 mb-10 rounded-md pt-3 pb-3"
                            onClick={() => handleDamageReport()}
                          >
                            Rapporter skade på utstyr
                          </Button>
                        </>
                      ) : null}
                      <Card className="text-black bg-white text-left w-12/12  mt-6 p-2 shadow-md border-gray">
                        <Card.Body className="pt-2 pr-1 pl-1 pb-2">
                          {order.deliveryService[0].order === false ? (
                            <>
                              <div className="text-sm tracking-wider pb-2 pt-2 pl-2 text-black">
                                Du må selv hente din bestilling på vårt lager i{" "}
                                <strong>
                                  {order.lager === "lorenskog" ? (
                                    <>Lørenskog</>
                                  ) : (
                                    <>
                                      {order.lager === "asker" ? (
                                        <>Asker</>
                                      ) : (
                                        <>
                                          {order.lager[0].toUpperCase() +
                                            order.lager.slice(1)}
                                        </>
                                      )}
                                    </>
                                  )}
                                </strong>
                                .{" "}
                                <a
                                  href="https://partylyd.no/hvor-finner-du-oss"
                                  className="text-red-900"
                                >
                                  Klikk her for adresse
                                </a>
                                .
                              </div>
                              <div className="text-sm tracking-wider pb-2 pt-2 pl-2 text-black">
                                Du kan hente din bestilling når som helst{" "}
                                <strong>
                                  {capitalize(
                                    new Date(
                                      order.tid.startDate.seconds * 1000
                                    ).toLocaleString(`no-NO`, options)
                                  )}
                                </strong>
                                , og bestilling må leveres tilbake i løpet av{" "}
                                <strong>
                                  {capitalize(
                                    new Date(
                                      order.tid.endDate.seconds * 1000
                                    ).toLocaleString(`no-NO`, options)
                                  )}
                                </strong>
                                .
                              </div>
                              <hr className="pb-2 mt-2" />
                              <div className="text-xs pb-2 pt-4 pl-2 text-[#24292e] tracking-widest">
                                HVORDAN HENTE BESTILLINGEN DIN
                              </div>
                              <Row md={1}>
                                <Col xs={2} md={1}>
                                  <img
                                    alt=""
                                    className="ml-2 mb-1 w-6 h-6"
                                    
                                    src={
                                      "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAOEAAADhCAMAAAAJbSJIAAAAZlBMVEUAAAD///8wMDAzMzP39/fy8vK5ublERERoaGj8/Pzh4eF6enocHBw/Pz+JiYmysrLt7e0iIiLOzs5aWlpTU1OlpaXU1NRLS0usrKxdXV1iYmLCwsImJibn5+dtbW2Tk5MUFBSLi4t08AjaAAADIElEQVR4nO3d2VLbMBSAYTve4jgLZAPSppT3f8nSYZlsSKo4Hp2j/v9lLk70jUjMxAQVZe4VqRcwegjth9B+CO2H0H4I7YfQfgjth9B+CO2H0H4I7YfQfgjtFyas26GrJpqquqGtxYSzaaGz6UxE2C9TQxwt++8Lm0VqhbNF811hM09t8DT3ET3CXvcO/m3h+UH1CDW/Bj9afkc4S736oNzvqG6h1svEedN4YZ167YE5L/1OYZt66YG10cIh9dIDG6KFXeqlB9ZFC6vUSw+sihZOUi89sAlChOpDiFB/CBHqDyFC/SFEqD+ECPWHEKH+ECKU7v7h4V52oi7hdt2UZbPeSM5UJVx9zN4JDlUk3Jz8WYEgUY/w8Wy63J0tLcKn4/l0ufuvSoSry+lHsdEqhE93N55bKg3Cqw3MTLi9sYFZCW9uYEbCze0NzEf41QbmIvziFZiP8NE1PQPh4eganoFw5/bZF3qB1oVbL9C68Ef2QtdlIgvhzxvjmoechPfX01bFxZPZFhaX18LmUGQmvPh99O0ji6yEk9Ovsty9fzyalfD0z8tXH4/lJSx+ve/i3eHzocyERfG8r5v16VenshNehTAyhAgFQxgZQoSCIYwMIULBEEaGEKFgCCNDiFAwhJEhRCgYwsgQIhQMYWQIEQqGMDKECAVDGBlChIIhjAwhQsEQRoYQoWAII0OIUDCEkSFEKBjCyBAiFOxsei82VpFwfzp9LzZWkfDsADG5E88UCU8PEBM88UyTsPo8XqsWPIhIk7D4vX4bvZc8V1GVsCg2u/V6J/qvL7UJRwghQv0hRKg/hAj1hxCh/hAi1B9ChPpD+D8L8z9bXe4UkXHrooVD6qUHNrgQTqHcOSnj1kYL69RLD6x2IZzCcpp67UFNnQa3UPAO2IjNnAa3UPAu5ni9uAkeYb9IvX5vi95N8AjLRvI+3xjNG4/AJywb3bu48AH9wrJ/Sa1w9OL5EQ0Svr6jar1oTN3vouHC10t/O3TVRFNVN7TOC/0/Ci2H0H4I7YfQfgjth9B+CO2H0H4I7YfQfgjth9B+CO2H0H75C/8A6QBqPcaxulsAAAAASUVORK5CYII="
                                    }
                                  />
                                </Col>
                                <Col xs={12} md={10} className="pt-1">
                                  <div className="text-sm tracking-wider text-black">
                                    Når leieperioden starter må du dra til vårt
                                    lager i{" "}
                                    <strong>
                                      {order.lager === "lorenskog" ? (
                                        <>Lørenskog</>
                                      ) : (
                                        <>
                                          {order.lager === "asker" ? (
                                            <>Asker</>
                                          ) : (
                                            <>
                                              {order.lager[0].toUpperCase() +
                                                order.lager.slice(1)}
                                            </>
                                          )}
                                        </>
                                      )}
                                    </strong>
                                    .
                                  </div>
                                </Col>
                              </Row>
                              <hr className="mb-2 mt-1 mx-3" />
                              <Row md={1}>
                                <Col xs={2} md={1}>
                                  <img
                                    alt=""
                                    className="ml-2 mb-1 mt-3 w-6 h-6"
                                    src={
                                      "data:image/png;base64,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"
                                    }
                                  />
                                </Col>
                                <Col xs={12} md={10} className="pt-1">
                                  <div className="text-sm tracking-wider text-black pb-2">
                                    Når du har kommet frem til lageret kan du{" "}
                                    <strong>låse opp</strong> lageret og hente
                                    din bestilling. Du låser opp lageret ved å
                                    gå til denne siden når leieperioden er
                                    startet, og følge instruksjonene.
                                  </div>
                                </Col>
                              </Row>
                              <hr />
                              <div className="text-xs pb-2 pt-8 pl-2 text-[#24292e] tracking-widest">
                                HVORDAN LEVERE BESTILLINGEN DIN
                              </div>
                              <Row md={1}>
                                <Col xs={2} md={1}>
                                  <img
                                    alt=""
                                    className="ml-2 mb-1 w-6 h-6"
                                    src={
                                      "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAOEAAADhCAMAAAAJbSJIAAAAZlBMVEUAAAD///8wMDAzMzP39/fy8vK5ublERERoaGj8/Pzh4eF6enocHBw/Pz+JiYmysrLt7e0iIiLOzs5aWlpTU1OlpaXU1NRLS0usrKxdXV1iYmLCwsImJibn5+dtbW2Tk5MUFBSLi4t08AjaAAADIElEQVR4nO3d2VLbMBSAYTve4jgLZAPSppT3f8nSYZlsSKo4Hp2j/v9lLk70jUjMxAQVZe4VqRcwegjth9B+CO2H0H4I7YfQfgjth9B+CO2H0H4I7YfQfgjtFyas26GrJpqquqGtxYSzaaGz6UxE2C9TQxwt++8Lm0VqhbNF811hM09t8DT3ET3CXvcO/m3h+UH1CDW/Bj9afkc4S736oNzvqG6h1svEedN4YZ167YE5L/1OYZt66YG10cIh9dIDG6KFXeqlB9ZFC6vUSw+sihZOUi89sAlChOpDiFB/CBHqDyFC/SFEqD+ECPWHEKH+ECKU7v7h4V52oi7hdt2UZbPeSM5UJVx9zN4JDlUk3Jz8WYEgUY/w8Wy63J0tLcKn4/l0ufuvSoSry+lHsdEqhE93N55bKg3Cqw3MTLi9sYFZCW9uYEbCze0NzEf41QbmIvziFZiP8NE1PQPh4eganoFw5/bZF3qB1oVbL9C68Ef2QtdlIgvhzxvjmoechPfX01bFxZPZFhaX18LmUGQmvPh99O0ji6yEk9Ovsty9fzyalfD0z8tXH4/lJSx+ve/i3eHzocyERfG8r5v16VenshNehTAyhAgFQxgZQoSCIYwMIULBEEaGEKFgCCNDiFAwhJEhRCgYwsgQIhQMYWQIEQqGMDKECAVDGBlChIIhjAwhQsEQRoYQoWAII0OIUDCEkSFEKBjCyBAiFOxsei82VpFwfzp9LzZWkfDsADG5E88UCU8PEBM88UyTsPo8XqsWPIhIk7D4vX4bvZc8V1GVsCg2u/V6J/qvL7UJRwghQv0hRKg/hAj1hxCh/hAi1B9ChPpD+D8L8z9bXe4UkXHrooVD6qUHNrgQTqHcOSnj1kYL69RLD6x2IZzCcpp67UFNnQa3UPAO2IjNnAa3UPAu5ni9uAkeYb9IvX5vi95N8AjLRvI+3xjNG4/AJywb3bu48AH9wrJ/Sa1w9OL5EQ0Svr6jar1oTN3vouHC10t/O3TVRFNVN7TOC/0/Ci2H0H4I7YfQfgjth9B+CO2H0H4I7YfQfgjth9B+CO2H0H75C/8A6QBqPcaxulsAAAAASUVORK5CYII="
                                    }
                                  />
                                </Col>
                                <Col xs={12} md={10} className="pt-1">
                                  <div className="text-sm tracking-wider text-black">
                                    Når leieperioden er over må du dra til vårt
                                    lager i{" "}
                                    <strong>
                                      {order.lager === "lorenskog" ? (
                                        <>Lørenskog</>
                                      ) : (
                                        <>
                                          {order.lager === "asker" ? (
                                            <>Asker</>
                                          ) : (
                                            <>
                                              {order.lager[0].toUpperCase() +
                                                order.lager.slice(1)}
                                            </>
                                          )}
                                        </>
                                      )}
                                    </strong>
                                    .
                                  </div>
                                </Col>
                              </Row>
                              <hr className="mb-2 mt-1 mx-3" />
                              <Row md={1}>
                                <Col xs={2} md={1}>
                                  <img
                                    alt=""
                                    className="ml-2 mb-1 mt-1 w-6 h-6"
                                    src={
                                      "data:image/png;base64,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"
                                    }
                                  />
                                </Col>
                                <Col xs={12} md={10} className="pt-1">
                                  <div className="text-sm tracking-wider text-black">
                                    Når du har kommet frem til lageret kan du{" "}
                                    <strong>låse opp</strong> lageret og levere
                                    din bestilling. Du låser opp lageret ved å
                                    gå til denne siden når leieperioden er
                                    startet, og følge instruksjonene.
                                  </div>
                                </Col>
                              </Row>
                            </>
                          ) : (
                            <>
                              {order.deliveryService[1].order === true ? (
                                <>
                                  <div className="text-sm tracking-wider pb-2 pt-2 pl-2 text-black">
                                    Du har bestilt levering til, og henting fra,{" "}
                                    <strong>
                                      {order.deliveryService[3].order}
                                    </strong>
                                    .
                                  </div>
                                  <div className="text-sm tracking-wider pb-2 pt-2 pl-2 text-black">
                                    Vi vil ta kontakt med deg på telefon, til
                                    nummeret <strong>{order.tlf}</strong> for å
                                    avtale nærmere tidspunkt for levering og
                                    henting.
                                  </div>

                                  <div className="text-sm tracking-wider pb-2 pt-2 pl-2 text-black italic">
                                    Hvis du ikke har hørt noe fra oss innen{" "}
                                    <strong>
                                      {new Date(
                                        (order.tid.startDate.seconds - 259200) *
                                          1000
                                      ).toLocaleString(`no-NO`, {
                                        weekday: "long",

                                        month: "long",
                                        day: "numeric",
                                      })}
                                    </strong>{" "}
                                    ta kontakt med oss. Du kan også kontakte oss
                                    dersom det er noe du lurer på angående
                                    levering og henting.
                                  </div>
                                  <Button
                                    className="lg:mt-0 mt-3 tracking-wide h-12 w-100"
                                    onClick={() => routeChange()}
                                    style={{
                                      backgroundColor: "#e57e22",
                                      border: "none",
                                      fontWeight: 400,
                                    }}
                                  >
                                    Ta kontakt
                                  </Button>
                                </>
                              ) : (
                                <>
                                  <div className="text-sm tracking-wider pb-2 pt-2 pl-2 text-black">
                                    Du har bestilt levering til{" "}
                                    <strong>
                                      {order.deliveryService[3].order}
                                    </strong>
                                    .
                                  </div>
                                  <div className="text-sm tracking-wider pb-2 pt-2 pl-2 text-black">
                                    Vi vil ta kontakt med deg på telefon, til
                                    nummeret <strong>{order.tlf}</strong> for å
                                    avtale nærmere tidspunkt for levering.
                                  </div>
                                  <div className="text-sm tracking-wider pb-2 pt-2 pl-2 text-black italic">
                                    Hvis du ikke har hørt noe fra oss innen{" "}
                                    <strong>
                                      {new Date(
                                        (order.tid.startDate.seconds - 259200) *
                                          1000
                                      ).toLocaleString(`no-NO`, {
                                        weekday: "long",

                                        month: "long",
                                        day: "numeric",
                                      })}{" "}
                                    </strong>
                                    ta kontakt med oss. Du kan også kontakte oss
                                    dersom det er noe du lurer på angående
                                    levering.
                                  </div>
                                  <Button
                                    className="lg:mt-0 mt-3 tracking-wide h-12 w-100"
                                    onClick={() => routeChange()}
                                    style={{
                                      backgroundColor: "#e57e22",
                                      border: "none",
                                      fontWeight: 400,
                                    }}
                                  >
                                    Ta kontakt
                                  </Button>
                                </>
                              )}
                            </>
                          )}
                        </Card.Body>
                      </Card>
                      <div className="pb-2 pt-10 font-normal text-3xl tracking-wider whitespace-pre">
                        Pris og betaling
                      </div>
                      {order.invoiceURL ? (
                        <>
                          <Button
                            variant="secondary"
                            className="bg-[#24292e] text-white tracking-wider mt-2 rounded-md py-2 px-3 flex"
                            onClick={() =>
                              window.open(order.invoiceURL, "_blank")
                            }
                          >
                            <FiDownload className="mr-2 mt-0.5" />
                            Last ned kvittering
                          </Button>
                        </>
                      ) : null}

                      <Card className="text-black bg-white text-left w-12/12 mt-6 shadow-md border-gray pl-2">
                        <Card.Body className="pt-2 pr-1 pl-1 pb-2">
                          <div className="text-sm tracking-wider pb-2 pt-2 pl-2 text-black">
                            <div>
                              <Row md={1} className="p-4">
                                <Col xs={6} md={8}>
                                  <div className="tracking-widest">
                                    <div>Pakkepris</div>
                                  </div>
                                </Col>
                                <Col xs={6} md={4}>
                                  <div className="tracking-widest text-right mr-2">
                                    {order.pakkePris},-
                                  </div>
                                </Col>
                              </Row>
                              {order.tilleggsPris ? (
                                <>
                                  <hr />
                                  <Row md={1} className="p-4">
                                    <Col xs={6} md={8}>
                                      <div className="tracking-widest">
                                        <div>Tilleggspris</div>
                                      </div>
                                    </Col>
                                    <Col xs={6} md={4}>
                                      <div className="tracking-widest text-right mr-2">
                                        {order.tilleggsPris},-
                                      </div>
                                    </Col>
                                  </Row>
                                </>
                              ) : null}
                              {extraEquiptmentPurchasedPrice > 0 ? (
                                <>
                                  <hr />
                                  <Row md={1} className="p-4">
                                    <Col xs={6} md={8}>
                                      <div className="tracking-widest">
                                        <div>
                                          Ekstra bestilling x{" "}
                                          {setNumberOfExtraOrders}
                                        </div>
                                      </div>
                                    </Col>
                                    <Col xs={6} md={4}>
                                      <div className="tracking-widest text-right mr-2">
                                        {extraEquiptmentPurchasedPrice},-
                                      </div>
                                    </Col>
                                  </Row>
                                </>
                              ) : null}
                              {order.rabattkode && order.rabattkode !== "" ? (
                                <>
                                  <hr />
                                  <Row md={1} className="p-4">
                                    <Col xs={6} md={8}>
                                      <div className="tracking-widest">
                                        <div>Benyttet rabattkode</div>
                                      </div>
                                    </Col>
                                    <Col xs={6} md={4}>
                                      <div className="tracking-widest text-right mr-2">
                                        {order.rabattkode}
                                      </div>
                                    </Col>
                                  </Row>
                                </>
                              ) : null}
                              {order.deliveryService[0].order === true &&
                              order.deliveryService[1].order === false ? (
                                <>
                                  <hr />
                                  <Row md={1} className="p-4">
                                    <Col xs={6} md={8}>
                                      <div className="tracking-widest">
                                        <div>Leveringspris</div>
                                      </div>
                                    </Col>
                                    <Col xs={6} md={4}>
                                      <div className="tracking-widest text-right mr-2">
                                        {order.deliveryService[0].pris},-
                                      </div>
                                    </Col>
                                  </Row>
                                </>
                              ) : null}
                              {order.deliveryService[1].order === true ? (
                                <>
                                  <hr />
                                  <Row md={1} className="p-4">
                                    <Col xs={6} md={8}>
                                      <div className="tracking-widest">
                                        <div>Leveringspris</div>
                                      </div>
                                    </Col>
                                    <Col xs={6} md={4}>
                                      <div className="tracking-widest text-right mr-2">
                                        {order.deliveryService[0].pris +
                                          order.deliveryService[1].pris}
                                        ,-
                                      </div>
                                    </Col>
                                  </Row>
                                </>
                              ) : null}
                              {order.deliveryService[2].order === true ? (
                                <>
                                  <hr />
                                  <Row md={1} className="p-4">
                                    <Col xs={6} md={8}>
                                      <div className="tracking-widest">
                                        <div>Monteringspris</div>
                                      </div>
                                    </Col>
                                    <Col xs={6} md={4}>
                                      <div className="tracking-widest text-right mr-2">
                                        {order.deliveryService[2].pris}
                                        ,-
                                      </div>
                                    </Col>
                                  </Row>
                                </>
                              ) : null}

                              {order.forsikring.bestilt ? (
                                <>
                                  <hr />
                                  <Row md={1} className="p-4">
                                    <Col xs={6} md={8}>
                                      <div className="tracking-widest">
                                        <div>Forsikring</div>
                                      </div>
                                    </Col>
                                    <Col xs={6} md={4}>
                                      <div className="tracking-widest text-right mr-2">
                                        {order.forsikring.pris},-
                                      </div>
                                    </Col>
                                  </Row>
                                </>
                              ) : null}
                              <div className="border-2 "></div>
                              <Row md={1} className="p-4">
                                <Col xs={6} md={8}>
                                  <div className="tracking-widest">
                                    <div>Totalpris</div>
                                    <div className="text-xs text-[#808080]">
                                      (Totalsum inkludert 25% MVA)
                                    </div>
                                  </div>
                                </Col>
                                <Col xs={6} md={4}>
                                  <div className="tracking-widest text-right mr-2">
                                    {Number(order.totalPris) +
                                      Number(extraEquiptmentPurchasedPrice)}
                                    ,-
                                  </div>
                                </Col>
                              </Row>
                              <div></div>
                            </div>
                          </div>
                        </Card.Body>
                      </Card>
                      <Card className="text-black bg-white text-left w-12/12 mt-6 shadow-md border-gray pl-2">
                        <Card.Body className="pt-2 pr-1 pl-1 pb-2">
                          <div className="text-sm tracking-wider text-black">
                            <Row md={1} className="px-4 py-2">
                              <Col xs={6} md={8}>
                                <div className="tracking-widest">
                                  <div>Betalt med</div>
                                </div>
                              </Col>
                              <Col xs={6} md={4}>
                                <div className="tracking-widest text-right mr-2">
                                  {order.betaling}
                                </div>
                              </Col>
                            </Row>
                            <hr />
                            <Row md={1} className="px-4 py-2">
                              <Col xs={6} md={5}>
                                <div className="tracking-widest">
                                  <div>Ordrenummer</div>
                                </div>
                              </Col>
                              <Col xs={6} md={7}>
                                <div className="tracking-widest text-right mr-2">
                                  {orderId.orderId}
                                </div>
                              </Col>
                            </Row>
                          </div>
                        </Card.Body>
                      </Card>
                    </Col>
                    <Col className="pt-10 pb-10">
                      <Row>
                        <Col md={7}>
                          <div className="pb-2 font-normal text-3xl tracking-wider whitespace-pre pt-2.5">
                            Din bestilling
                          </div>
                        </Col>
                        {window.innerWidth > 960 ? (
                          <Col md={5}>
                            <Button
                              variant="secondary"
                              className="focus:ring-4 font-josefin shadow-sm transform active:scale-y-75 transition-transform"
                              onClick={() => {
                                setShowExtraEquipmentModal(true);
                              }}
                              style={{
                                fontWeight: 1000,
                                backgroundColor: "#2289e5",
                                borderColor: "#2289e5",
                                paddingLeft: "1.5rem",
                                paddingRight: "1.5rem",
                                paddingTop: "1.0rem",
                                paddingBottom: "1.0rem",
                                marginBottom: "1rem",
                              }}
                            >
                              <div className="flex">
                                <div className="pt-0.5 pr-2">
                                  <GoPlus />
                                </div>
                                Legg til ekstra utstyr
                              </div>
                            </Button>
                          </Col>
                        ) : null}
                      </Row>
                      <Row>
                      <Card className="text-black bg-white text-left w-12/12 mt-6 shadow-md border-gray pl-2">
                        <Card.Body className="pt-2 pr-1 pl-1 pb-2">
                          <div className="text-sm tracking-wider pb-2 pt-2 pl-2 text-black">
                            <div className="text-xl pb-4 pt-2 tracking-widest">
                              {order.pakkeType}
                            </div>
                            <div>
                              Din bestilling starter{" "}
                              <strong>
                                {capitalize(
                                  new Date(
                                    order.tid.startDate.seconds * 1000
                                  ).toLocaleString(`no-NO`, options)
                                )}
                              </strong>{" "}
                              og varer til{" "}
                              <strong>
                                {capitalize(
                                  new Date(
                                    order.tid.endDate.seconds * 1000
                                  ).toLocaleString(`no-NO`, options)
                                )}
                              </strong>
                              , totalt {order.tid.totalDays} dager.
                            </div>
                            <div></div>
                            {equipment ? (
                              <div>
                                <Row>
                                  <Col>
                                    <Card className="pt-4 pl-2 mb-2 rounded-xl border-none">
                                      {equipment.map(
                                        (products: {
                                          id: Key | null | undefined;
                                          bilde: string | undefined;
                                          beskrivelse: string | undefined;
                                          navn: string | undefined;
                                          count: number | undefined;
                                        }) => (
                                          <div
                                            //@ts-ignore
                                            key={products.id}
                                          >
                                            <OrderList
                                              //@ts-ignore
                                              bilde={products.bilde}
                                              //@ts-ignore
                                              beskrivelse={products.beskrivelse}
                                              //@ts-ignore
                                              navn={products.navn}
                                              //@ts-ignore
                                              count={products.count}
                                            />
                                          </div>
                                        )
                                      )}
                                    </Card>
                                  </Col>
                                </Row>
                              </div>
                            ) : (
                              <div></div>
                            )}
                            <div>
                              {newEquipment ? (
                                <div>
                                  <Row>
                                    <Col>
                                      <Card className="pt-4 pl-2 mb-2 rounded-xl border-none">
                                        {newEquipment.map(
                                          (products: {
                                            id: Key | null | undefined;
                                            bilde: string | undefined;
                                            beskrivelse: string | undefined;
                                            navn: string | undefined;
                                            count: number | undefined;
                                          }) => (
                                            <div
                                              //@ts-ignore
                                              key={products.id}
                                            >
                                              <OrderList
                                                //@ts-ignore
                                                bilde={products.bilde}
                                                //@ts-ignore
                                                beskrivelse={
                                                  products.beskrivelse
                                                }
                                                //@ts-ignore
                                                navn={products.navn}
                                                //@ts-ignore
                                                count={products.count}
                                              />
                                            </div>
                                          )
                                        )}
                                      </Card>
                                    </Col>
                                  </Row>
                                </div>
                              ) : (
                                <div></div>
                              )}
                            </div>
                          </div>
                        </Card.Body>
                      </Card>
                      </Row>
                      <Row>
                      <Card className="text-black bg-white text-left w-12/12 mt-6 shadow-md border-gray pl-2">
                        <Card.Body className="pt-2 pr-1 pl-1 pb-2">
                          <div className="text-sm tracking-wider pb-2 pt-2 pl-2 text-black">
                            <div className="text-xl pb-4 pt-2 tracking-widest">
                              Monteringsinformasjon for {order.pakkeType}
                            </div>
                            <ul className="m-6">
                              {monteringsInfo.map((item, index) => (
                                <li className="mb-3" key={index}>
                                  {" "}
                                  {item.beskrivelse}{" "}
                                </li>
                              ))}
                            </ul>
                          </div>
                        </Card.Body>
                      </Card>
                        
                      </Row>
                    </Col>
                  </Row>
                </>
              ) : null}
              {!order.paymentStatus ? (
              <>
                <Container className="contact-content flex">
                  <Row className="mt-2 justify-content-center">
                    <Col className="mb-4" xs={12} md={10}>
                      <div className="pt-10 font-normal text-3xl tracking-wider whitespace-pre">
                        Velg betalingsmetode
                      </div>
                    </Col>
                    
                    <Col className="mb-4" xs={6} md={3}>
                      <Card
                        className="p-2"
                        onClick={() => {
                          setIsShownVipps(true);
                          setPaymentType();
                        }}
                      >
                        <Card.Body className="pt-2 pr-1 pl-1 pb-2">
                          {isShownVipps ? (
                            <div
                              style={{
                                width: "100%",
                                height: "25vh",
                                objectFit: "contain",
                                display: "block",
                                marginLeft: "auto",
                                marginRight: "auto",
                              }}
                            >
                              <Col
                                style={{
                                  display: "flex",
                                  justifyContent: "center",
                                  alignItems: "center",
                                  textAlign: "center",
                                  minHeight: "25vh",
                                }}
                              >
                                <Loading color={"#e57e22"} />
                              </Col>
                              </div>
                            ) : (
                              <img
                                alt="vipps"
                                onClick={() => {
                                  vippsThing(data);
                                }}
                                style={{
                                  width: "100%",
                                  height: "25vh",
                                  objectFit: "contain",
                                  display: "block",
                                  marginLeft: "auto",
                                  marginRight: "auto",
                                }}
                                src={
                                  "https://storage.googleapis.com/partylyd2022.appspot.com/images/vipps_logo_rgb.png?fbclid=IwAR2k_cJAHGNrn-hcXgPHvDhkgjVYfadPb-56zQZhnNJbMAlT3BW3fldNZlc"
                                }
                              />
                            )}
                          </Card.Body>
                          <Card.Footer>
                            <div className="text-sm tracking-wider pb-2 pt-2 pl-2 text-black">
                              Vipps
                            </div>
                          </Card.Footer>
                        </Card>
                      </Col>
                      <Col className="mb-4" xs={6} md={3}>
                        <Card
                          className="p-2"
                          onClick={() => {
                            setIsShownStripe(true);
                          }}
                        >
                          <Card.Body className="pt-2 pr-1 pl-1 pb-2">
                            {isShownStripe ? (
                              <div
                                style={{
                                  width: "100%",
                                  height: "25vh",
                                  objectFit: "contain",
                                  display: "block",
                                  marginLeft: "auto",
                                  marginRight: "auto",
                                }}
                              >
                                <Col
                                  style={{
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                    textAlign: "center",
                                    minHeight: "25vh",
                                  }}
                                >
                                  <Loading color={"#e57e22"} />
                                </Col>
                              </div>
                            ) : (
                              <img
                                alt="card"
                                onClick={() => {
                                  <Loading />;
                                  stripeThing(data);
                                }}
                                style={{
                                  width: "100%",
                                  height: "25vh",
                                  objectFit: "contain",
                                  display: "block",
                                  marginLeft: "auto",
                                  marginRight: "auto",
                                }}
                                src={
                                  "https://storage.googleapis.com/partylyd2022.appspot.com/images/stripe.png?fbclid=IwAR2IXkxNAkbeHbXXxrxJ8-T14vnU4mNhTiMlDWeNaGIlM_zWIMm6ah1F5I8"
                                }
                              />
                            )}
                          </Card.Body>
                          <Card.Footer>
                            <div className="text-sm tracking-wider pb-2 pt-2 pl-2 text-black">
                              Betalingskort
                            </div>
                          </Card.Footer>
                        </Card>
                      </Col>
                      {/* Foreløpig funker ikke */}

                      
                      {/* <Col className="mb-4" xs={6} md={3}>
                        <Card className="p-2">
                          <Card.Body className="pt-2 pr-1 pl-1 pb-2">
                            <img
                              alt="faktura"
                              onClick={() => {
                                vippsLoginFunction(data.client_reference_id);
                              }}
                              style={{
                                width: "100%",
                                height: "25vh",
                                objectFit: "contain",
                                display: "block",
                                marginLeft: "auto",
                                marginRight: "auto",
                              }}
                              src={
                                "https://storage.googleapis.com/partylyd2022.appspot.com/images/invoiceIkon.jpeg"
                              }
                            />
                          </Card.Body>
                          <Card.Footer>
                            <div className="text-sm tracking-wider pb-2 pt-2 pl-2 text-black">
                              Faktura for bedrift - Logg inn enkelt med Vipps
                            </div>
                          </Card.Footer>
                        </Card>
                      </Col> */}
                      <Col className="mb-4" xs={11} md={9}>
                        <div>
                          {" "}
                          {showVipps && (
                            <Vipps totalSum={order.totalPris} />
                          )}{" "}
                        </div>
                        <div> {showCardPayment && <StripePayment />} </div>
                        <div>
                          {" "}
                          {showFaktura && (
                            <Faktura
                              totOrderAmount={order.totalPris}
                              onClick={() =>
                                setDetailsForFaktura(
                                  formNavnMottaker.value,
                                  formOrgNummer.value,
                                  formAdresse.value,
                                  formPostNummer.value,
                                  formEmail.value,
                                  formMobil.value
                                )
                              }
                            />
                          )}{" "}
                        </div>
                      </Col>
                    </Row>
                  </Container>
                </>
              ) : null}
            </div>
          </Container>
        </>
      )}
    </div>
  );
};

export default OrderDetail;
